export const BASE_INPUT_CONTAINER_CLASS = 'mb-24 lg:mb-40 w-full lg:w-1/2';
export const BASE_INPUT_STRIPE_CONTAINER =
  'mb-24 lg:mb-40 w-full lg:w-1/2 flex flex-col';
export const STRIPE_INPUT =
  'rounded-5 border border-solid border-gray-dark h-56 py-16 px-16 rounded-5';

export const stripeFields: {
  id: string;
  label: string;
  field: stripe.elements.elementsType;
  placeholder: string;
  extraFields?: any;
}[] = [
  {
    id: '#cardNumber',
    label: 'Número de la tarjeta',
    placeholder: 'Tarjeta de Crédito o Débito',
    field: 'cardNumber',
    extraFields: {
      showIcon: true,
    },
  },
  {
    id: '#cardCvc',
    label: 'Código de seguridad',
    placeholder: 'Código de seguridad',
    field: 'cardCvc',
  },
  {
    id: '#cardExpiry',
    label: 'Fecha de expiración',
    placeholder: 'MM/AA',
    field: 'cardExpiry',
  },
  {
    id: '#postalCode',
    label: 'Código Postal',
    placeholder: 'Código Postal',
    field: 'postalCode',
  },
];
